$(function () {
    'use strict'

	var activeHorzTab = window.location.href.split('#horz')[1];
	$('#horz' + activeHorzTab).show();

    $('#periodLever').click(function () {
        $('.month-end-data').toggle();
        $('.quarter-end-data').toggle();
    });

	$('#yearLever').click(function () {
		$('.current-year-data').toggle();
		$('.previous-year-data').toggle();
	});

    //$('#performance-table, #pricing-table, #distribution-table, #rankings-table').tablesorter();

	$('#productTypeSelect, #listingShareClassSelect').change(function () {
        var url = new URL(window.location.href);
        var search_params = url.searchParams;

		if ($('#productTypeSelect').length) {
			search_params.set('productType', $('#productTypeSelect').val());
        }
		if ($('#listingShareClassSelect').length) {
			search_params.set('shareClass', $('#listingShareClassSelect').val());
		}

        url.search = search_params.toString();

        var new_url = url.toString();

		//splitting off the hash doesn't keep the right tab open
		//new_url = new_url.split('#')[0];

        window.location.href = new_url;

	});

	//Table Sort Settings
	$('.fund-table').tablesorter({
		headers: {
			0: {
				sorter: false
			},
			'.inceptDate': {
				sorter: false
			}
		},
		headerTemplate: '{content} {icon}',
		cssIcon: 'fad',
		cssIconNone: 'fa-sort',
		cssIconAsc: 'fa-sort-up',
		cssIconDesc: 'fa-sort-down',
		cssIconDisabled: 'hide',
		textExtraction: {
			1: function (node, table, cellIndex) {
				return $(node).find('a').text();
			}
		},
		widgets: ["filter"],
		widgetOptions: {
			filter_columnFilters: false,
			filter_filteredRow: 'hide',
			filter_external: '#productType',
			filter_reset: '#resetBtn'
		}
	});

	$('#resetBtn').click(function () {
		window.location.href = window.location.href.split(/[?#]/)[0];
	});








	$(document).ready(function () {
		$('#page-nav ul li').first().addClass('active');


		// MonthPicker
		var date = new Date(),
			year = date.getFullYear(),
			prevYear = year - 1,
			month = date.getMonth(),
			maxDate = new Date(year, month + 1),
			date = new Date(year, month);

		var subtractMonthFlag = document.getElementById("subtractMonth");

		if (subtractMonthFlag != null && subtractMonthFlag.value) {
			date = new Date(year, month - 1);
			maxDate = new Date();
		};

		$('#dist_period').monthpicker({
			autoClose: false,
			minYear: prevYear,
			maxYear: year,
			maxDate: maxDate,
			format: 'mmmm / yyyy',
			setDefaultDate: true,
			defaultDate: date,
		});

		$('.datepicker-done').click(function () {

			if ($('#productTypeSelect').length) {
				var productType = $('#productTypeSelect').val();
			}
			if ($('#listingShareClassSelect').length) {
				var shareClass = $('#listingShareClassSelect').val();
			}

			var isEquityOnlyFlag = document.getElementById("equityOnlyFlag").value;
			var fundListingType = document.getElementById("fundListingType").value;

			var date = $(".distribution-picker")[0].M_Datepicker.date;

			$.ajax({
				url: "/FundListingPage/GetDistributionTable",
				method: 'GET',
				dataType: 'HTML',
				data: {
					date: date,
					shareClass: shareClass,
					productType: productType,
					isEquityOnlyFlag: isEquityOnlyFlag,
					fundListingType: fundListingType
				}
			}).done(function (html) {
				$('#distTable').html(html);
				$('.fund-table').trigger("update");
                if (date.getMonth() == 11) {
					$('#equityDecMessage').hide();
				}
                else {
					$('#equityDecMessage').show();
                }

			}).fail(error => console.log(error));

		});

	});
	//Update Active State for On-Page Navigation
	var addClassOnScroll = function () {
		var windowTop = $(window).scrollTop();
		$('.data-page').each(function (index, elem) {
			var offsetTop = $(elem).offset().top;
			var outerHeight = $(this).outerHeight(true);
			if (windowTop > (offsetTop - fixedHeader - 1) && windowTop < (offsetTop + outerHeight)) {
				var elemId = $(elem).attr('id');
				$("#page-nav ul li.active a").parent('li').removeClass('active');
				$("#page-nav ul li a[href='#" + elemId + "']").parent('li').addClass('active');
			}
		});
	};

	$(function () {
		$(window).on('scroll', function () {
			addClassOnScroll();
		});
	});


});

